"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getWatchedPercentage = void 0;
var getWatchedPercentage = function (currentTime, mediaDuration) { return Math.round((currentTime * 100) / mediaDuration); };
exports.getWatchedPercentage = getWatchedPercentage;
